import { DEFAULT_LOCATIONS, JPMC_PROVIDER_LOOKUP, CHECKMARK } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token eb317fea4665f3ff3c9891e21963ef7edcee565f',
  staging: 'Token 40f464407ea683844765b58690aa4cb2025a64a8',
  prod: 'Token a3c5145e2ed0fee817cfaefa072b6662458a0f58',
};

const token = selectToken(apiTokens);

const jpmcProviderLookupConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'jpmc-cigna-providerlookup',

  API_TOKEN: token,
  EMBOLD_CLIENT: JPMC_PROVIDER_LOOKUP,

  // login
  SHOW_REGION_SELECTOR: false,

  // other
  BENEFITS_CHANGE: false,
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Chicago },
  LOGIN_NETWORK_NAME: 'jpmcProviderLookupUserId',

  // content
  DISPLAY_NAME: 'Cigna',
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: true,
};

export default jpmcProviderLookupConfig;
